import { render, staticRenderFns } from "./DateBase.vue?vue&type=template&id=44498b6e"
import script from "./DateBase.vue?vue&type=script&lang=js"
export * from "./DateBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports